<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h1>请填写信息，获取相关技术支持</h1>
      </div>
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请填写您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请填写您的手机号"></el-input>
        </el-form-item>
        <el-form-item label="厂区" prop="customer">
          <el-input v-model="form.customer" placeholder="请填写您所在厂区"></el-input>
        </el-form-item>
        <el-form-item label="机型" prop="model">
          <el-input v-model="form.model" placeholder="请填设备型号"></el-input>
        </el-form-item>
        <el-form-item label="问题类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择问题类型">
            <el-option label="机械问题" value="机械问题"></el-option>
            <el-option label="电气问题" value="电气问题"></el-option>
            <el-option label="其他问题" value="其他问题"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述" prop="desc">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请详细填写您所遇到的问题及需求" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(form)">提交</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
//import axios from 'axios'
import { MessageBox } from 'element-ui';
export default {
  name: 'HelloWorld',
  data () {
    return {
      form: {
        name: '',
        phone: '',
        customer: '',
        type: '',
        model: '',
        desc: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写您的手机号', trigger: 'blur' }
        ],
        customer: [
          { required: true, message: '请输入所在厂区', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择问题类型', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请输入机型', trigger: 'blur' }
        ],
        desc: [
          { required: true, message: '请输入问题详情', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    onSubmit () {
      // eslint-disable-next-line no-console
      this.$refs.form.validate((valid) => {
        if (valid) {
          let config = {
            headers: {
              'Content-Type': 'application/json',
            },
          }
          const JsonData = {
            "status" : 0,
            "name" : this.form.name,
            "phone" : this.form.phone,
            "customer": this.form.customer,
            "model": this.form.model,
            "type": this.form.type,
            "desc": this.form.desc,
            "is_delete": 0
          }
          this.$http.post('/feedbacks' , JsonData , config)
            .then((res) => {
              if(res.data.code === 0){
                const { name, phone } = res.data.data;
                MessageBox.confirm(
                  `联系人：${name} <br> 电话：${phone}`,
                  {
                    confirmButtonText: '拨打电话',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    showCancelButton: true,
                    type: 'info'
                  }
                ).then(() => {
                  window.location.href = `tel:${phone}`;
                }).catch(() => {
                });
              }else{
                this.$message.error(res.data.msg)
              }
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error(error);
            });
        }
      })
    }
  }
}
</script>

<style>
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  h1{
    text-align:center;
    font-size:20px;
  }
  .el-message-box{
    width:90vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue